/**
 * Utility to extract Meta Pixel ID from various user inputs (raw ID or full base code snippet)
 * @param {string} input - User raw input
 * @returns {string} Clean numeric Pixel ID or empty string
 */
export function parseMetaPixelId(input) {
    if (!input) return "";
    const trimmed = input.trim();
    
    // 1. If it's just a sequence of digits (usually 15-16 characters), return it
    if (/^\d+$/.test(trimmed)) {
        return trimmed;
    }
    
    // 2. Try to find the ID in fbq('init', 'ID')
    const fbqMatch = trimmed.match(/fbq\s*\(\s*['"]init['"]\s*,\s*['"](\d+)['"]/);
    if (fbqMatch && fbqMatch[1]) {
        return fbqMatch[1];
    }
    
    // 3. Try to find the ID in the noscript URL tr?id=ID
    const urlMatch = trimmed.match(/tr\?id=(\d+)/);
    if (urlMatch && urlMatch[1]) {
        return urlMatch[1];
    }
    
    // 4. Fallback: Search for any 15-16 digit sequence of numbers
    const numberMatch = trimmed.match(/\b\d{15,16}\b/);
    if (numberMatch) {
        return numberMatch[0];
    }
    
    // 5. General fallback: return any sequence of digits
    const anyNumberMatch = trimmed.match(/\d+/);
    if (anyNumberMatch) {
        return anyNumberMatch[0];
    }
    
    return "";
}
